import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { httpService } from "~/core/http_service";

import type { UpdateUserPayload, UserInformation } from "../types";

const updateUser = ({ data }: UpdateUserPayload): Promise<UserInformation> => {
  const {
    passport_image,
    top_national_card_image,
    first_birth_certificate_page_image,
    profile_picture,
    ...rest
  } = data;

  const payload: Record<string, unknown> = {
    ...rest,
    passport_image: passport_image?.url,
    top_national_card_image: top_national_card_image?.url,
    first_birth_certificate_page_image: first_birth_certificate_page_image?.url,
    profile_picture: profile_picture?.url,
  };

  return httpService.request<UserInformation>({
    url: "/users/",
    method: "PATCH",
    payload,
  });
};

export const useUpdateProfile = () => {
  return useMutation<UserInformation, AxiosError, UpdateUserPayload>({
    mutationKey: ["users", "update"],
    mutationFn: updateUser,
  });
};
